// The tenant detail's tabs (spec 15 §4 S5 Overview, S6 Entitlements, S7
// Usage, S10 Support, S23 Agents). Each tab is its own route, so a link or a
// reload lands on the tab. Each section that ships adds its own tab here; a section whose
// store does not exist yet has no tab at all (D-033).

import { useTranslation } from "react-i18next";
import { RouterTabs } from "../../../components/tabs";

export function TenantTabs({ tenantId }: { tenantId: string }) {
  const { t } = useTranslation();
  return (
    <RouterTabs
      label={t("admin.tenantTabs.label")}
      className="admin-tenant-tabs"
      data-testid="admin-tenant-tabs"
      tabs={[
        {
          to: `/console/tenants/${tenantId}`,
          label: t("admin.tenantTabs.overview"),
          exact: true,
          "data-testid": "admin-tenant-tab-overview",
        },
        {
          to: `/console/tenants/${tenantId}/entitlements`,
          label: t("admin.tenantTabs.entitlements"),
          "data-testid": "admin-tenant-tab-entitlements",
        },
        {
          to: `/console/tenants/${tenantId}/usage`,
          label: t("admin.tenantTabs.usage"),
          "data-testid": "admin-tenant-tab-usage",
        },
        // M15-8 (D-620): S10, the support actions.
        {
          to: `/console/tenants/${tenantId}/support`,
          label: t("admin.support.tabSupport"),
          "data-testid": "admin-tenant-tab-support",
        },
        // D-645: S23, the agents and their model profiles.
        {
          to: `/console/tenants/${tenantId}/agents`,
          label: t("admin.agentModels.tab"),
          "data-testid": "admin-tenant-tab-agents",
        },
      ]}
    />
  );
}
